import { notifications as notificationsApi, notes as notesApi } from "../../api/endpoints";
import { AddToast } from "../../components/feedback/Toast";
import { APP_URL } from "../../config";

// ── Detail-view actions shared by talents and organisations ─────────────────
// Each of these used to be a toast with nothing behind it. They now write into
// the platform: a notification the user actually receives, an internal note
// only admins see, and a link into the live app.

export function openInApp(path: string, addToast: AddToast) {
  if (!APP_URL) {
    addToast("Set REACT_APP_APP_URL to link through to the live app", "info");
    return;
  }
  window.open(`${APP_URL}${path}`, "_blank", "noopener,noreferrer");
}

export function sendNotificationTo(
  role: "talent" | "org",
  id: string,
  name: string,
  addToast: AddToast
) {
  const title = window.prompt(`Notification title for ${name}:`, "A message from Donatella");
  if (title === null || !title.trim()) return;
  const body = window.prompt("Message:", "");
  if (body === null) return;

  notificationsApi.send({ role, id, title: title.trim(), body })
    .then(() => addToast(`Notification sent to ${name}`, "success"))
    .catch((e) => addToast(e instanceof Error ? e.message : "Failed to send notification", "error"));
}

export function addInternalNote(
  entityType: "Talent" | "Organisation",
  id: string,
  name: string,
  addToast: AddToast
) {
  const note = window.prompt(`Internal note about ${name} (never shown to them):`, "");
  if (note === null || !note.trim()) return;

  notesApi.create({ entity_type: entityType, entity_id: id, note: note.trim() })
    .then(() => addToast("Note saved", "success"))
    .catch((e) => addToast(e instanceof Error ? e.message : "Failed to save note", "error"));
}
